/**
 * Balance Display Component
 * Shows the user's current balance and currency
 */

import type { FC} from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useBalance } from 'store/app/appStore';
import { testIds } from 'core/testIds';

import styles from './StatusBar.module.css';

export const BalanceDisplay: FC = memo(() => {
    const { t } = useTranslation();
    const balance = useBalance();

    return (
        <div className={styles.balanceContainer} data-testid={testIds.statusBar.balance}>
            <div className={styles.balanceAmountRow}>
                <span className={styles.balanceAmount} data-testid={testIds.statusBar.balanceAmount}>{balance.formattedBalance || '0.00'}</span>
                <span className={styles.balanceCurrency} data-testid={testIds.statusBar.balanceCurrency}>{balance.currency || 'USD'}</span>
            </div>
            <span className={styles.balanceCaption}>{t('generic_balance', 'Balance')}</span>
        </div>
    );
});

BalanceDisplay.displayName = 'BalanceDisplay';
